import { useTheme, useMediaQuery } from "@mui/material"
import { Breakpoint } from "@mui/material/styles"

export default function useSize(direction: "up" | "down", size?: Breakpoint) {
	const theme = useTheme()
	const compare = direction === "up" ? theme.breakpoints.up(size ?? 0) : theme.breakpoints.down(size ?? Infinity)
	return useMediaQuery(compare)
}
